namespace liveChatModule {

    class LiveChatButton {

        public showThanks: boolean = false;

        constructor (
            private liveChatService: LiveChatService
        )
        {
            this.liveChatService.addReactiveButton();
        }

        public startChat = ():void => {
            if(TRPCONFIG.Domain.LiveChat.Ready) {
                this.liveChatService.startChat(TRPCONFIG.Domain.LiveChat.ReactiveButtonCode);
            }
        }

        public startOfflineChat = ():void => {
            if(TRPCONFIG.Domain.LiveChat.Ready) {
                this.liveChatService.startChat(TRPCONFIG.Domain.LiveChat.ReactiveOfflineButtonCode);
            }
        }

    }

    angular
        .module('liveChatModule')
        .directive('liveChatButton', (): ng.IDirective => {
            return {
                scope: {},
                replace: true,
                bindToController: {},
                controller: LiveChatButton,
                controllerAs: 'lcb',
                templateUrl: `partials/home/liveChatButton`
            };
        });
}
